import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  BehaviorSubject,
  catchError,
  from,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IserverService {
  private readonly proxyUrl = environment.iServerLambdaProxyUrl;

  accessToken?: string;

  taskResponse: Subject<{ statusCode: number; body: any }> = new Subject();

  constructor(private http: HttpClient, private msalService: MsalService) {}

  private createDispatcherBody(
    token: string,
    task: string,
    url?: string,
    body?: object
  ) {
    return {
      iServerAccessToken: token,
      iServerUrl: url,
      iServerBody: body || '',
      iServerTask: task,
    };
  }

  public query(iServerUrl: string) {
    return this.callDispatcher({ iServerTask: 'Query', iServerUrl }).pipe(
      map((response) => response.body)
    );
  }

  public executeTask(
    iServerTask: string,
    iServerBody: object
  ): Observable<any> {
    return this.callDispatcher({ iServerTask, iServerBody }).pipe(
      tap((response) => {
        console.log('taskResponse', response);
        this.taskResponse.next({
          statusCode: response.status,
          body: response.body,
        });
      }),
      map((response) => response.body)
    );
  }

  private callDispatcher(params: {
    iServerTask: string;
    iServerUrl?: string;
    iServerBody?: object;
  }): Observable<any> {
    return this.getAccessToken().pipe(
      switchMap((accessToken) => {
        return this.http.post(
          this.proxyUrl,
          this.createDispatcherBody(
            accessToken,
            params.iServerTask,
            params.iServerUrl,
            params.iServerBody
          ),
          { observe: 'response' }
        );
      }),
      catchError((err) => {
        console.log('Error', err.errorMessage);
        return of('Error occured: ', err.errorMessage);
      })
    );
  }

  private getAccessToken(): Observable<string> {
    if (this.accessToken) {
      return of(this.accessToken);
    } else {
      return from(
        this.msalService.acquireTokenSilent({
          scopes: environment.iServerScopes,
        })
      ).pipe(
        tap((authResponse) => (this.accessToken = authResponse.accessToken)),
        map((authResponse) => authResponse.accessToken)
      );
    }
  }
}
